import { UseQueryOptions } from '@tanstack/react-query'
import { budgetCommentsKeys } from './budgetCommentsQueryKeys'
import type { BudgetComment } from '../types'
import { fetchComments } from '../services/budgetCommentsService'

export interface CommentsQueryParams {
  companyId: string
  budgetingScenarioId?: number | null
  dimensions?: string
}

/**
 * Creates query options for comments query
 * Use this factory to ensure consistent query configuration across all hooks
 * Note: dimensions is intentionally excluded from the query key
 */
export const createCommentsQueryOptions = (
  params: CommentsQueryParams
): UseQueryOptions<BudgetComment[], Error, BudgetComment[]> => ({
  queryKey: budgetCommentsKeys.commentsData({
    companyId: params.companyId,
    budgetingScenarioId: params.budgetingScenarioId
  }),
  queryFn: () => fetchComments(params),
  enabled: !!params.companyId,
  staleTime: 5 * 60 * 1000, // 5 minutes
  gcTime: 10 * 60 * 1000, // 10 minutes
  refetchOnMount: true,
  refetchOnWindowFocus: false
})
